document.addEventListener('DOMContentLoaded', function () {
    (function() {
        function moveShippingInfo() {
            const info = document.querySelector('.fixed-shipping-info');
            const calculator = document.querySelector('#shipping_calculator--');

            if (info && calculator && info.nextElementSibling !== calculator) {
                calculator.parentNode.insertBefore(info, calculator);
                console.log('Fixed Shipping Info reposicionado.');
                }
        }

        moveShippingInfo();

        const observer = new MutationObserver(moveShippingInfo);
            observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        window.addEventListener('load', moveShippingInfo);
    })();
});